export default {
  tabs: {
    register: '会員登録',
    scan: 'スキャン設定',
    right: '会員特典説明',
    privacy: 'プライバシーポリシー',
  },
  register: {
    conditions: 'アカウント登録条件',
    phone: '電話番号',
    phoneCode: '電話認証コード',
    email: 'メール',
    emailCode: 'メール認証コード',
    saveRule: '少なくとも1つのログイン方式と対応する認証方式を選択してください',
    savePhoneVerifyRule: '電話番号の認証方式を選択してください',
    saveEmailVerifyRule: 'メールの認証方式を選択してください',
  },
  scan: {
    label: 'スキャンごとに',
    countSuffix: '回、追加',
    growthSuffix: '成長値',
    countPlaceholder: '回数を入力してください',
    valuePlaceholder: '入力してください',
    tooltip: '消費者がシステム製品のQRコードをスキャンする際（有効スキャン回数は初回スキャンがその消費者であることを意味します）、スキャン回数に応じて成長値が加算されます。',
    saveCountRule: 'スキャン回数を入力してください',
    saveValueRule: '成長値を入力してください',
  },
  agreement: {
    title: '会員特典説明',
    viewTip: '（ユーザー側で会員特典を確認できます）',
    intro: '会員規約の内容を編集します。言語ごとに異なるバージョンを管理できます。',
    language: '言語',
    addLang: '多言語を追加',
    delete: '削除',
    editorPlaceholder: '内容を入力してください',
    saveBeforeSwitch: '現在の内容は保存されていません。保存しますか？',
  },
  rules: {
    title: 'ルール説明',
    intro1: '1. プライバシーポリシーは、消費者に対して会員センターがどのように個人情報を収集、使用、共有するかを説明するためのものです。データの用途、保存方法、セキュリティなどの詳細情報が含まれ、消費者が会員センター機能を利用する際に、このポリシーに同意する必要があります。',
    intro2: '2. 多国籍のユーザーに対応する場合は、各国の言語でプライバシーポリシーを管理し、コンプライアンスに準拠した表示を確保する必要があります。',
    intro: '会員ルール説明の内容を編集します。言語ごとに異なるバージョンを管理できます。',
    titleField: 'タイトル',
    language: '言語',
    addLang: '多言語を追加',
    delete: '削除',
    saveBeforeSwitch: '現在の内容は保存されていません。保存しますか？',
  },
  addI18nModal: {
    titleAgreement: '規約を追加',
    titleRules: 'ルール説明を追加',
    language: '言語',
    languagePlaceholder: '言語を選択してください',
    content: '内容',
  },
  deleteConfirm: '削除後は元に戻せません。削除してもよろしいですか？',
};
